import script from "./FraudDetectionDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./FraudDetectionDetails.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__